import CollectionOrderDetail from "../symbols/collectionOrderDetail";

const initialState = {
  data: [],
  loading: false,
  error: false,
};

export default function CollectionOrderDetailReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case CollectionOrderDetail.COLLECTION_ORDER_DETAIL_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };
    case CollectionOrderDetail.COLLECTION_ORDER_DETAIL_FAILURE:
      return {
        ...state,
        data: initialState.data,
        loading: false,
        error: true,
      };
    case CollectionOrderDetail.COLLECTION_ORDER_DETAIL:
      return {
        ...state,
        data: initialState.data,
        loading: true,
        error: false,
      };
      case CollectionOrderDetail.CLEAR_COLLECTION_ORDER_DETAIL:
      return {
        ...state,
        data: initialState.data,
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
